<template>
  <Legacy
    view="reports"
    action="invoicing"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Invoicing Reports (Old)',
      breadcrumb: {
        name: 'Invoicing Reports (Old)',
        route: { name: 'reports-legacy-invoice' }
      }
    }
  }
}
</script>
